import React, { ReactNode } from 'react'
import { Box, BoxProps, Paragraph, Stack, TextButton } from '@ui'

import { ContractInfoButtons } from './ContractInfoButtons'

type Props = {
    canEdit: boolean | undefined
    onEdit: () => void
    name: string | undefined
    owner: string | undefined
    address: string
}

const MdGap = ({ children, ...boxProps }: { children: ReactNode } & BoxProps) => (
    <Box padding="md" gap="md" {...boxProps} background="level2" rounded="sm">
        {children}
    </Box>
)

export function EditTownInfo(props: Props) {
    const { canEdit, onEdit, name, address } = props

    return (
        <MdGap>
            <Stack gap="paragraph">
                <Stack horizontal alignItems="center" width="100%">
                    <Paragraph strong truncate size="lg" color="default">
                        {name ?? ''}
                    </Paragraph>
                    <Box grow />
                    {canEdit && (
                        <TextButton data-testid="edit-button" onClick={onEdit}>
                            Edit
                        </TextButton>
                    )}
                </Stack>
                <ContractInfoButtons contractAddress={address} />
            </Stack>
        </MdGap>
    )
}
